import React from 'react'
import { motion } from 'framer-motion'

import circles from '../../../assets/images/benefits/accordions-circles.svg'
import image from '../../../assets/images/benefits/accordions-image.webp'
import Accordion from '../../../components/accordion/Accordion'
import Animations from '../../../utils/animations'
import useStyles from '../Benefits.styles'

export default function BenefitsAccordions () {
  const classes = useStyles()

  return (
    <>
      <div className={classes.accordionContainer}>
        <div className={classes.accordionColumn}>
          <div className={classes.accordionEmployersContainer}>
            <h2 className={classes.accordionTitle}>A win-win platform</h2>
            <h3 className={classes.accordionSubtitle}>Explore company-wide benefits at a glance</h3>
            <div className='web-subhead pb-5'>For Employers</div>
            <div className='pb-5 mb-5'>
              <Accordion content={employersAccordion} />
            </div>
          </div>
          <div className={classes.accordionCaptionContainer}>
            <motion.img
              className={classes.accordionCaptionImage}
              src={image}
              alt='Employers'
              {...Animations.FADE()}
            />
            <div>
              <span className={classes.accordionCaptionAccent}>Drive Business Success </span>
              <span className={classes.accordionCaption}>
                by Focusing on Employee Happines and Loyalty
              </span>
            </div>
          </div>
        </div>
        <div className={classes.accordionColumn}>
          <div className={classes.accordionEmployeesContainer}>
            <motion.img
              src={circles}
              alt='Employees'
              className={classes.accordionEmployersImage}
              {...Animations.POP()}
            />
            <div className='web-subhead pb-5'>For Employees</div>
            <div className='pb-5 mb-5'>
              <Accordion content={employeesAccordion} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const employersAccordion = [
  {
    title: 'Attract talent',
    textLine1:
      'According to a recent Harris survey¹ over 80% of those polled said they would take a job with an employer that offers wages on demand over an employer that does not.',
    disclaimer: '¹ Study conducted by The Harris Poll on behalf of Ceridian. August 2021.'
  },
  {
    title: 'Keep talent',
    textLine1:
      'Employees in that same poll1 overwhelmingly 79% said earned wage access would make them feel more valued as an employee.'
  },
  {
    title: 'Lower absenteeism',
    textLine1:
      'When employees have control over their pay they are less stressed, more motivated, and more engaged.'
  },
  {
    title: 'Reach HR goals',
    textLine1:
      'In-platform spot bonuses and gifts are a low-cost way to say “thank you” for a job well done, or to mark a special occasion like a birthday.'
  },
  {
    title: 'Lessen the burden on your HR department',
    textLine1:
      'Our platform is easy to set up and easy to run at ZERO COST to you. Remove expenses and administrative burden all at once.'
  }
]

const employeesAccordion = [
  {
    title: 'Financial Control',
    textLine1:
      'With access to their paycheck or tips without having to wait for payday, employees have more control over their finances overall.'
  },
  {
    title: 'Peace of mind',
    textLine1:
      'As reported in a 2021 Wagestream report, 77% of EWA users felt less stress and 88% reduced reliance on high-cost payday loans.'
  },
  {
    title: 'Safety net',
    textLine1:
      'Imagine the relief of being able to cover a large bill or sudden expense without having to pay interest of any kind.'
  },
  {
    title: 'Easy access to banking services²',
    textLine1:
      "Nearly half of working-class Americans are underbanked or unbanked because they don't meet the minimum requirements to open a bank account³.",
    textLine2:
      'The Multikrd Prepaid Mastercard Card is accessible to most Americans, with simple application requirements and a great user experience to manage their funds with ease.',
    disclaimer: [
      '² Multikrd is not a bank. The Multikrd Prepaid Card is issued by Central Bank of Kansas City, Member FDIC.',
      '³ 2023 FDIC National Survey of Unbanked and Underbanked Households'
    ]
  },
  {
    title: 'International Money Transfers',
    textLine1:
      'Over 32 million U.S adults send international remittances each year, supporting family members and communities abroad. These funds totaled about $800 billion globally in 2022, highlighting the vital role they play in supporting loved ones in need⁴. Powered by RIA Money Transfer, your employees can send their earnings securely to over 190 countries with more than 500,000 convenient pickup locations, all from the app. This service offers fast transfers and transparent tracking, making it easier for them to support family and friends back home directly from their earned wage.',
    disclaimer:
      '⁴ "Remittances: Why Sending Money Home Helps More than Families," World Economic Forum, February 2023. "Key facts about global migration and remittances," Pew Research Center, June 29, 2023.'
  },
  {
    title: 'Cashback, again and again',
    textLine1:
      'Our MK platform offers cashback at popular retailers, allowing employees to accrue extra cash for a rainy day or special occasion.'
  },
  {
    title: 'Customized coupons and savings',
    textLine1:
      'We offer more than a million perks and discounts on groceries, restaurants, clothing, and more.'
  },
  {
    title: 'Travel discounts galore',
    textLine1: 'Cars, vacations, and flights are just the beginning.'
  }
]
